<template>
  <VIcon :title="$t('lock')" style="font-size: 1rem; vertical-align: baseline">
    mdi-lock
  </VIcon>
</template>

<script>
export default {
  name: 'VacancyLockInfo',
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
  lock: Interview by invitation only
</i18n>

<i18n locale="ru" lang="yaml">
  lock: Закрытая вакансия. Запись собеседований только по приглашению.
</i18n>
